<template>
  <div class="chart-container">
    {{ labels }}
    <CanvasJSChart :options="chartOptions" :styles="styleOptions"/>
  </div>
</template>

<script>
export default {
  name: 'TicketsDepartmentChart',
  props: {
    departmentData: {
      type: Object,
      default: () => ({
        labels: [],
        colors: [],
        series: []
      })
    }
  },
  computed: {
    chartOptions() {
      return {
        theme: "light2",
        animationEnabled: true,
        title: {
          text: ""
        },
        data: [{
          type: "pie",
          indexLabel: "{label}",
          yValueFormatString: "#,##0",
          toolTipContent: "<span style='color: {color};'>{label}</span>: {y} tickets",
          dataPoints: this.generateDataPoints(),
          radius: "80%",
          innerRadius: "0%"
        }]
      }
    },
    styleOptions() {
      return {
        width: "100%",
        height: "315px"
      }
    }
  },
  methods: {
    generateDataPoints() {
  if (!this.departmentData) {
    return [];
  }

  const { labels = [], series = [], colors = [] } = this.departmentData;
  const maxLength = Math.max(labels.length, series.length, colors.length);

  return Array.from({ length: maxLength }).map((_, index) => ({
    label: labels[index] || `Department ${index + 1}`,
    y: series[index] ?? 0, // Use 0 if undefined
    color: colors[index] || this.getDefaultColor(index)
  }));
},
    getDefaultColor(index) {
      const defaultColors = [
        "#bb282e", "#00005b", "#012239", "#FF6B6B", 
        "#FFD93D", "#6BCB77", "#4ECDC4", "#45B7D1", 
        "#96CEB4", "#FFEAA7", "#DDA0DD", "#98D8C8"
      ];
      return defaultColors[index % defaultColors.length];
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 90% !important;
  height: 315px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
}
.canvasjs-chart-credit{
  display: none !important;
}
</style>